import { useRef as a, useEffect as f, useCallback as v } from "react";
function x(n, E = {}) {
  const { enabled: l = !0, excludeRefs: s = [], useCapture: t = !0, debounceMs: c = 0 } = E, o = a(n), r = a();
  f(() => {
    o.current = n;
  }, [n]);
  const i = v(
    (e) => {
      r.current && clearTimeout(r.current), c > 0 ? r.current = setTimeout(() => {
        o.current(e);
      }, c) : o.current(e);
    },
    [c]
  );
  f(() => {
    if (!l) return;
    const e = (d) => {
      const m = d.target;
      s.some(
        (u) => u.current && (u.current === m || u.current.contains(m))
      ) || i(d);
    };
    return document.addEventListener("scroll", e, t), window.addEventListener("scroll", e, t), () => {
      document.removeEventListener("scroll", e, t), window.removeEventListener("scroll", e, t), r.current && clearTimeout(r.current);
    };
  }, [l, s, t, i]);
}
export {
  x as useEventOnScroll
};
